import { Component, OnInit } from '@angular/core';
import { BusyIndicatorService } from './busy-indicator.service';

@Component({
  selector: 'app-busy-indicator',
  templateUrl: './busy-indicator.component.html',
  styleUrls: ['./busy-indicator.component.css']
})
export class BusyIndicatorComponent implements OnInit {

  constructor(
    private service: BusyIndicatorService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/busy-indicator/busy-indicator.component.ts